import {request, serviceUrl} from "@/utils/request";

// 获取视频信息
export function getDVRInfo(brandEnum, username, password, ip) {
  return request({
    method: 'post',
    url: serviceUrl.cameraService + '/dvr/device-info',
    data: {
      brandEnum: brandEnum,
      username: username,
      password: password,
      ip: ip
    }
  })
}

//云台控制 参数分别是: 品牌,通道名称,ip,密码,端口,控制类型,控制动作(开始,停止),用户名
export function ptzControl(brandEnum,channel,ip,password,port,ptzCommandEnum,stop,username){
  return request({
    method: 'post',
    url: serviceUrl.cameraService+'/dvr/ptz-control',
    data:{
      brandEnum: brandEnum,
      channel: channel,
      ip: ip,
      password: password,
      port: port,
      ptzCommandEnum: ptzCommandEnum,
      stop: stop,
      username: username
    }
  })
}

//云台控制-预置点控制 参数分别是: 品牌,通道名称,ip,密码,端口,控制类型,预置点序号,用户名
export function ptzPreset(brandEnum,channel,ip,password,port,ptzCommandEnum,dwPresetIndex,username){
  return request({
    method: 'post',
    url: serviceUrl.cameraService+'/dvr/ptz-preset',
    data:{
      brandEnum: brandEnum,
      channel: channel,
      ip: ip,
      password: password,
      port: port,
      ptzCommandEnum: ptzCommandEnum,
      dwPresetIndex: dwPresetIndex,
      username: username
    }
  })
}

//获取门禁主机工作状态
export function getDoorAcsWorkStatus(brandEnum, ip, password, username) {
  return request({
    method: 'post',
    url: serviceUrl.cameraService + '/dvr/get-door-acs-work-status',
    data: {
      brandEnum: brandEnum,
      ip: ip,
      password: password,
      port: 8000,
      username: username
    }
  })
}

//获取门禁设备日志
export function getDvrDoorLogs(brandEnum, ip, password, username, startTime, endTime) {
  return request({
    method: 'post',
    url: serviceUrl.cameraService + '/dvr/get-door-logs',
    data: {
      brandEnum: brandEnum,
      ip: ip,
      password: password,
      port: 8000,
      username: username,
      startTime: startTime,
      endTime: endTime
    }
  })
}

//获取门参数
export function getDvrDoorConfig(brandEnum, ip, password, username, channel) {
  return request({
    method: 'post',
    url: serviceUrl.cameraService + '/dvr/get-door-config',
    data: {
      brandEnum: brandEnum,
      ip: ip,
      password: password,
      port: 8000,
      username: username,
      channel: channel
    }
  })
}

//控制门
export function controlDvrDoor(brandEnum, ip, password, username, channel, dwStaic) {
  return request({
    method: 'post',
    url: serviceUrl.cameraService + '/dvr/control-dvr-door',
    data: {
      brandEnum: brandEnum,
      ip: ip,
      password: password,
      port: 8000,
      username: username,
      channel: channel,
      dwStaic: dwStaic,
    }
  })
}
